<template>

<div>
<template v-if="data.read_only_state">
  {{inputdata}}
    
  </template>

  <template v-if="!data.read_only_state">
    <template v-if="data.validation_type=='date'">
      <Calendar 
      v-model="inputdata" 
      class="w-full p-inputtext-sm mb-0" 
      :class="{'p-invalid':char_length_err }" 
      :disabled="data.submissions.length && data.submissions[0].is_nulled" 
      :showButtonBar="true"
      @update:modelValue="fieldChanged"
      dateFormat="dd-mm-yy"
      />
    </template>
    <template v-else>
      <InputText  
      type="text" 
      v-model="inputdata"  
      class="w-full p-inputtext-sm mb-0" 
      :class="{'p-invalid':char_length_err }" 
      @input="fieldChanged" 
      :disabled="data.submissions.length && data.submissions[0].is_nulled" 
      @blur="inputfieldblur"
      />
    </template>
    
    <small  class="p-error pt-2" v-if="char_length_err"> {{char_length_err_message}}</small>
  </template>

</div>

</template>

<script>
import moment from "moment"
export default {

  name: 'TextType',
  props:["data"],

  data () {
    return {
    	inputdata:null,
    	intervalobj:null,
      char_length_err:null,
      char_length_err_message:null,
    }
  },
  mounted()
  {
  	 if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_text
        if(this.data.validation_type=="date")
        {
          this.inputdata = moment(this.inputdata).format('DD-MM-YYYY');

        }
      }
  	
  },
  computed:{
    propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_text
        return propdata
      }
    }
  },
  watch:{
    propdata(newval)
    {

      console.log("propdata");
      console.log(newval)
      if(this.data.validation_type=="date")
      {
        if(newval)
        {
          this.inputdata = moment(this.inputdata).format('DD-MM-YYYY');
        }
        else
        {
          this.inputdata = null
        }
        
      }
      else
      {
        this.inputdata = newval
      }
    },
    data()
    {
      console.log("watch")
      console.log(this.data)
      if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_text
      }
      else
      {
        this.inputdata = null
      }
    }
  },
  methods: {
    test()
    {
      console.log(this.data)
    },
    inputfieldblur()
    {
      this.char_length_err = false
      this.char_length_err_message = null
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
      this.submitInputData()
    },
  	fieldChanged()
  	{
      
      this.char_length_err = false
      this.char_length_err_message = null
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},3000)
  	},
  	submitInputData()
  	{
      console.log("submitInputData")
      console.log(this.inputdata)
  		clearInterval(this.intervalobj);
      if(this.data.min_char_length && this.inputdata.length<this.data.min_char_length)
      {
        this.char_length_err = true
        this.char_length_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_karakter_sayisi+this.data.min_char_length

        let ind = this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == this.data.id})
        this.$store.state.evaluation.inputfields[ind].completion = false
        this.checkQueslionlistConditions()
        return false
      }

      if(this.data.max_char_length && this.inputdata.length>this.data.max_char_length)
      {
        this.char_length_err = true
        this.char_length_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_karakter_sayisi+this.data.max_char_length

        let ind = this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == this.data.id})
        this.$store.state.evaluation.inputfields[ind].completion = false
        this.checkQueslionlistConditions()
        return false
      }

      if(this.data.submissions[0] && this.inputdata==this.data.submissions[0].submission_text)
      {
        return false
      }
      //console.log(this.inputdata)
      if(this.data.validation_type=="url")
      {     
        if(this.isValidUrl) 
        {
          let http_check = this.inputdata.slice(0, 4);
          console.log(http_check)
          if(http_check!=="http" && http_check!=="HTTP" )
          {
              this.char_length_err = true
              this.char_length_err_message = this.$store.state.languages.lang_phrases.gecersiz_url
              return false
          }
        }  
        else
        {
          this.char_length_err = true
          this.char_length_err_message = this.$store.state.languages.lang_phrases.gecersiz_url
          return false
        }
      }
      if(this.data.validation_type=="email")
      {
        let check = this.isValidEmail()
        if(!check)
        {
          this.char_length_err = true
          this.char_length_err_message = this.$store.state.languages.lang_phrases.gecersiz_email
          return false
        }
      }
  		let formdata = new FormData()
  		formdata.append("text",this.inputdata)
  		formdata.append("type","text")
  		formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)
      console.log(this.inputdata);
  		this.submitInputFieldSubmission(formdata,this.data.id)
  	},
    isValidEmail()
    {
      let emailInput = this.inputdata
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(emailInput)) {
        return true
      } else {
        return false
      }

    },
    isValidUrl() {
      try {
        new URL(this.inputdata);
        return true;
      } catch (err) {
        return false;
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>